export const changeCustomModalOpen = (open: boolean) => {
   if (open) {
      document.documentElement.classList.add('custom-modal-open');
      document.body.classList.add('custom-modal-open');
   } else {
      document.documentElement.classList.remove('custom-modal-open');
      document.body.classList.remove('custom-modal-open');
   }
};
